import React from 'react'
import {findDOMNode} from 'react-dom'
import ControlButtonStandard, {ControlButtonType} from "../../buttons/control-button/control-button-standard"
import Popover from "../../gd-popover/popover-v2"
import PopoverPosition from "../../gd-popover/popover-position"
import {PopoverAttachmentType} from "../../gd-popover/@const"

type Props = {
    className?                  : string,
    style?                      : any

    type?                       : ControlButtonType
    size?                       : 24 | 28,

    menuComponent               : any,  // component with menu - skin gd-popup-menu-btn
    menuParams                  : any,                    // menu component params - vaznaya shtuka (!) dlya handlers ?
    hint?                       : string,                      // optional hint for the btnComponenr
    iconClass?                  : string,                 // optional hint for the btnComponenr

    popoverClass?               : string,   // popover classname

    attachment?                 : string,
    targetAttachment?           : string,
    attachmentType?             : 'horizontal'|'vertical',
    offset?                     : string,

    outsideClickIgnoreClasses?  : string[] | string,     // string or array of strings, nodes classes clicks on which are ignored
    clickOutsideDelay?          : number,

    disabled?                   : boolean,                     // if true - no click + disabled class

    // callback
    onTogglePopover?            : callback

    children?                   : any
    enableAttachments?          : boolean
}

// use .show-popover class to keep visible when popup menu open !!!!

export default class ControlButtonMenu extends React.Component<Props> {

    private popoverKeyDownListener  : any

    static defaultProps = {
        disabled            : false,
        attachment          : "top right",
        targetAttachment    : "bottom right",
        attachmentType      : "horizontal",
        offset              : "0 -10",
    }

    state = {
        showPopover: false
    }

    preventPropagation = (e:React.SyntheticEvent) => {
        e.stopPropagation()
    }

    onPopoverKeyDown = (e:React.SyntheticEvent) => {
        this.popoverKeyDownListener?.onPopoverKeyDown(e)
    }

    onClickOutside = (e:React.SyntheticEvent) => {
        if(this.props.outsideClickIgnoreClasses && gd.utils.Dom.findNodeByClassName(e.target, this.props.outsideClickIgnoreClasses)) {
            return
        }

        this.hidePopover()
    }

    showPopover = (e: React.MouseEvent) => {
        if (e) {
            e.stopPropagation()
        }

        if (this.props.disabled) {
            return
        }

        this.setState({
            showPopover: true
        }, () => {
            this.props.onTogglePopover?.(true)
        })
    }

    hidePopover = () => {
        this.setState({
            showPopover: false
        }, () => {
            this.props.onTogglePopover?.(false)
        })
    }

    togglePopover = (e:React.SyntheticEvent) => {
        e.stopPropagation()

        if (this.props.disabled) {
            return
        }

        const showPopover = !this.state.showPopover
        this.setState(()=> ({
            showPopover: showPopover
        }), () => {
            this.props.onTogglePopover?.(showPopover);
        })
    }

    onPopoverKeyDownListener = (listener:any) => {
        this.popoverKeyDownListener = listener
    }

    renderPopover = () => {
        const MenuComponent = this.props.menuComponent

        const popoverPosition = new PopoverPosition({
            attachment      : this.props.attachment,
            targetAttachment: this.props.targetAttachment,
            offset          : this.props.offset,
            attachmentType  : this.props.attachmentType as PopoverAttachmentType,
        })

        return (
            <Popover
                popoverClass        = {Classes("gd-popup-menu", this.props.popoverClass)}
                position            = {popoverPosition}
                onKeyDown           = {this.onPopoverKeyDown}
                onClickOutside      = {this.onClickOutside}
                clickOutsideDelay   = {this.props.clickOutsideDelay}
                getTargetFunc       = {()=>findDOMNode(this)}
            >
                <MenuComponent
                    hidePopover                 = {this.hidePopover}
                    menuParams                  = {this.props.menuParams}
                    onPopoverKeyDownListener    = {this.onPopoverKeyDownListener}
                />
            </Popover>
        )
    }

    render() {
        const classes = Classes(this.props.iconClass, this.props.className, {
            "show-popover"  : this.state.showPopover,
            'disabled'      : this.props.disabled,
        })

        const hint = (this.props.hint && !this.state.showPopover) ? this.props.hint : undefined

        return (
            <ControlButtonStandard
                style        = {this.props.style}
                hint         = {hint}
                iconClass    = {classes}
                type         = {this.props.type}
                onClick      = {this.togglePopover}
                size         = {this.props.size}
            >

                {this.props.children}
                {this.state.showPopover &&
                    this.renderPopover()
                }
            </ControlButtonStandard>
        )
    }
}

